<template>
  <dx-list class="navbar-buttons">
    <dx-list-item>
      <dx-icon title="Ajuda" size="lg" icon="question-circle" />
    </dx-list-item>

    <dx-list-item>
      <dx-icon title="Notificações" size="lg" icon="bell" />
    </dx-list-item>

    <dx-list-item>
      <dx-icon @click.stop="onUserMenuClick" title="Seu perfil" size="lg" icon="circle-user" />
    </dx-list-item>
  </dx-list>

  <transition name="slide" v-click-outside="closeNavbarAside">
    <dx-navbar-aside v-if="opened">
      <dx-avatar size="md" />
      <div class="first-name">
        <dx-heading size="sm">Olá, {{ this.firstName }}!</dx-heading>
      </div>
      <div @click="closeNavbarAside" @keyDown="closeNavbarAside">
        <dx-navbar-aside-item description="Minha conta" redirect-page="MeEditData" />
        <dx-navbar-aside-item
          description="Administração" redirect-page="AdminHome" v-if="isAdmin" />
        <dx-navbar-aside-item description="Sair" :action="this.logoutAction" />
      </div>
    </dx-navbar-aside>
  </transition>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleUser, faQuestionCircle, faBell } from '@fortawesome/free-solid-svg-icons';
import vClickOutside from 'click-outside-vue3';

library.add(faCircleUser, faQuestionCircle, faBell);

export default {
  name: 'dx-navbar',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  emits: ['logoutAction'],
  props: {
    firstName: {
      type: String,
      default: '',
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    logoutAction() {
      this.$emit('logoutAction');
    },
    closeNavbarAside() {
      this.opened = false;
    },
    onUserMenuClick() {
      this.opened = !this.opened;
    },
  },
};
</script>
<style scoped lang="scss">
.navbar-buttons {
  list-style-type: none;
  column-gap: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  li {
    float: left;
    cursor: pointer;
    color: var(--dx-color--blue-light) !important;
  }

  li:last-child {
    margin-right: var(--dx-space-size--xs);
  }

  .fa-circle-question:hover, .fa-bell:hover, .fa-user:hover{
      color: var(--dx-color--blue);
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: transform ease-in-out 0.4s;
}
.slide-enter-from,
.slide-leave-to {
  transform: translate(100%, 0);
}

.dx-avatar {
  margin: auto;
  display: block;
  margin-bottom: var(--dx-space-size--sm);
  margin-top: var(--dx-space-size--md);
}

.first-name {
  text-transform: capitalize;
  text-align: center;
  margin-bottom: var(--dx-space-size--sm);
}

.dx-navbar-aside {
  right: 0 !important;
  left: auto !important;
}
</style>
